import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly TOKEN_KEY = 'authToken'
  private readonly TIMESTAMP_KEY = 'tokenTimestamp'
  private readonly EXPIRATION_TIME = 12 * 60 * 60 * 1000
  private readonly PERMISSIONS = 'permissions'
  private readonly INFOS = 'infos'
  private readonly baseUrl = environment.baseUrl

  constructor() {}

  saveToken(token: string): void {
    const currentTime = new Date().getTime()
    localStorage.setItem(this.TOKEN_KEY, token)
    localStorage.setItem(this.TIMESTAMP_KEY, currentTime.toString())
  }

  saveInfo(info: any): void {
    const infosJson = {
      id: info.id,
      name: info.nome,
      email: info.email,
      idPerfil: info.idPerfil,
      perfil: info.perfil,
      funcionarioId: info.funcionarioId,
      funcionarioFuncaoId: info.funcionarioFuncaoId,
      funcionarioFuncaoDescricao: info.funcionarioFuncaoDescricao,
      pessoaId: info.pessoaId,
      pessoaFisicaId: info.pessoaFisicaId,
    }

    localStorage.setItem(this.INFOS, JSON.stringify(infosJson))
  }

  getInfosObject(): any | null {
    const info = localStorage.getItem(this.INFOS)
    if (info) {
      return JSON.parse(info)
    } else {
      return null
    }
  }

  clearInfos(): void {
    localStorage.removeItem(this.INFOS)
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY)
  }

  isTokenValid(): boolean {
    const tokenTimestamp = localStorage.getItem(this.TIMESTAMP_KEY)
    if (tokenTimestamp) {
      const currentTime = new Date().getTime()
      const tokenAge = currentTime - parseInt(tokenTimestamp, 10)
      return tokenAge < this.EXPIRATION_TIME
    }
    return false
  }

  clearToken(): void {
    localStorage.removeItem(this.TOKEN_KEY)
    localStorage.removeItem(this.TIMESTAMP_KEY)
  }

  savePermissions(permissions: any[]): void {
    localStorage.setItem(this.PERMISSIONS, JSON.stringify(permissions))
  }

  getPermissions(): string | null {
    return localStorage.getItem(this.PERMISSIONS)
  }

  getPermissionsObject(): any | null {
    const permissions = localStorage.getItem(this.PERMISSIONS)
    if (permissions) {
      return JSON.parse(permissions)
    } else {
      return null
    }
  }

  checkPermission(permission: string, screen: string): boolean {
    const permissionsList = this.getPermissionsObject()
    for (let i = 0; i < permissionsList.length; i++) {
      let item = permissionsList[i]
      if (
        item.nomeTela.toLowerCase() == screen &&
        item.nomeFuncao.toLowerCase() == permission
      ) {
        return true
      }
    }
    return false
  }

  clearPermissions(): void {
    localStorage.removeItem(this.PERMISSIONS)
  }

  login(token: string): void {
    this.saveToken(token)
  }

  logout(): void {
    this.clearToken()
    this.clearPermissions()
    this.clearInfos()
  }

  validURl(): boolean {
    if (this.baseUrl.includes('api.tgmob-homolog.prolins.com.br')) {
      return false
    } else {
      return true
    }
  }
}
